import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { CompositeDataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/composite-data-set-config';
import { CompositeDataSetRecipe } from 'libs/end-to-end/src/types/databases/data-sets/composite-data-set-config';
import { TaggedDataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';

export interface DataSetEditCompositeHook {
  config: CompositeDataSetConfig;
  setConfig: Setter<CompositeDataSetConfig>;
}

export const useDataSetEditComposite = (): DataSetEditCompositeHook => {
  const [taggedReferences, setTaggedReferences] = useState<
    TaggedDataSetReference[]
  >([]);
  const [scriptContents, setScriptContents] = useState<string>('');

  const [recipe, setRecipe] = useState<CompositeDataSetRecipe | null>(null);

  const [runOrchestrationOnBatch, setRunOrchestrationOnBatch] =
    useState<boolean>(false);

  const [runScriptOnBatch, setRunScriptOnBatch] = useState<boolean>(false);

  const setConfig = useCallback((config: CompositeDataSetConfig) => {
    setTaggedReferences(config.taggedDataSetReferences);
    setScriptContents(config.pythonScriptContents);
    setRecipe(config.recipe);
    setRunOrchestrationOnBatch(config.runOrchestrationOnBatch);
    setRunScriptOnBatch(config.runScriptOnBatch);
  }, []);

  return useMemo(() => {
    return {
      config: {
        dataSetType: 'Composite',
        taggedDataSetReferences: taggedReferences,
        pythonScriptContents: scriptContents,
        recipe: recipe,
        runOrchestrationOnBatch: runOrchestrationOnBatch,
        runScriptOnBatch: runScriptOnBatch,
      },
      setConfig,
    };
  }, [
    taggedReferences,
    scriptContents,
    setConfig,
    recipe,
    runOrchestrationOnBatch,
    runScriptOnBatch,
  ]);
};
